import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MDBBootstrapModulePro } from 'libs/mdbootstrap/typescripts/pro/index';
import { MDBBootstrapModule } from 'libs/mdbootstrap/typescripts/free/index';
import { ProcessService } from 'app/core/process/process.service';
import { ModalModule } from 'app/modal/modal.module';
import { CoreModule } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { NewsFeedModule } from 'app/home/newsFeed/newsFeed.module';


@NgModule({
  imports: [
    MDBBootstrapModule,
    MDBBootstrapModulePro,
    CommonModule,
    TranslateModule,
    CoreModule,
    SharedModule,
    HomeRoutingModule,
    ModalModule,
    NewsFeedModule
  ],
  declarations: [
    HomeComponent
  ],
  providers: [
    ProcessService
  ]
})
export class HomeModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/home/home.module.ts